import React from 'react'
import { Outlet } from 'react-router-dom'

export const RegionsBase: React.FC = () => {
  return <Outlet />
}
